// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { requestRmaButtonsStyles } from "@vanmeter/Overrides/Widgets/RequestRma/RequestRmaButtons";
import { css } from "styled-components";

requestRmaButtonsStyles.sendButton = {
    variant: "primary",
    css: css`
        width: 100%;
    `,
};

requestRmaButtonsStyles.cancelButton = {
    buttonType: "outline",
    css: css`
        width: 100%;
    `,
};

requestRmaButtonsStyles.buttonsContainer = {
    css: css`
        margin-top: 12px;
        display: flex;
        gap: 12px;
        flex-direction: column;
    `,
};

